// extracted by mini-css-extract-plugin
export default {"button-more":"ButtonPlus_button-more__em4UM","button-more__label":"ButtonPlus_button-more__label__BneBj","button-more__icon":"ButtonPlus_button-more__icon__TMxIW"};